// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1fRHW","left":"InfoRow_left__3Hcy7"};